import WrapperLayout from 'components/Layout';
import Main from './components/Main';
const BimiAnalysis = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default BimiAnalysis